import dayjs from 'dayjs'
import React from 'react'
import { useEffect, useMemo, useState } from 'react'
import { setRemoteCall } from '../../remote'
import { getGlobalState, useGlobalState, setGlobalState } from '../../store'
import Boards from './Boards'
import ResourcesComponent from './Resources'

import Modals from './Modals'

const BoardsWrapper = (props) => {
  const [viewOptions] = useGlobalState('viewOptions')
  // const [projects, setProjects] = useGlobalState('projects')
  const [projects] = useGlobalState('projects')
  // const [resources, setResources] = useGlobalState('resources')
  const [resources] = useGlobalState('resources')
  const [resourceTypes] = useGlobalState('resourceTypes')
  // const [allUsers, setUsers] = useGlobalState('users')
  const [allUsers] = useGlobalState('users')
  const [userTypes] = useGlobalState('userTypes')

  const [fromColumn, setFromColumn] = useState(false)

  const [dayResources, setDayResources] = useState([])
  const [collapsedProjects, setCollapsedProjects] = useState([])

  // lets filter users by state
  let users = allUsers.filter((u) => u.status < 2)
  /**
   * Setup initial data
   */
  const currentDate = viewOptions.date //need to update this with controllers
  let searchDate = dayjs(currentDate)
  let items = 1
  if (viewOptions.displayType === 'week') {
    items = 6
    searchDate = dayjs(currentDate).startOf('isoWeek')
  }

  /**
   * need to reset day resrocess on view change
   */
  useEffect(() => {
    setDayResources([])
  }, [viewOptions])

  /**
   * When we click on the card we should open the correct edit modal
   * @param {*} e
   * @param {*} type
   */
  const onClick = (e, type) => {
    if (type === 'toggleProjectCollapse') {
      if (collapsedProjects.includes(e)) {
        setCollapsedProjects(collapsedProjects.filter((p) => p !== e))
      } else {
        setCollapsedProjects([...collapsedProjects, e])
      }
      return
    }
    if (type === 'people')
      setGlobalState(
        'openUserModal',
        users.find((u) => u._id === e)
      )
    if (type === 'project')
      setGlobalState(
        'openProjectModal',
        projects.find((u) => u._id === e)
      )

    if (type === 'resources')
      setGlobalState(
        'openResourceModal',
        resources.find((u) => u._id === e)
      )
  }

  /**
   * On drop card back into resrouce picker we need to add it back
   * removing is done when droped into collumn to prevent car disapering into ether
   * @param {*} e
   */
  const dropResourceCard = (e) => {
    const { addedIndex, payload } = e
    if (!addedIndex) return null
    setRemoteCall(
      'unsetRelationToProject',
      {
        _id: payload.relationId,
        date: fromColumn,
      },
      null
    )
  }

  //use memo for week day resources
  const RenderWeek = () =>
    useMemo(() => {
      return (
        <>
          <Boards
            {...{
              onClick: onClick,
              setFromColumn: setFromColumn,
              dayResources,
              setDayResources,
              collapsedProjects: collapsedProjects,
            }}
          />

          <ResourcesComponent
            {...{
              // resources: availableResources,
              // users: availableUsers,
              resources,
              resourceTypes: resourceTypes,
              users: users,
              userTypes: userTypes,
              dropResourceCard: dropResourceCard,
              onClick: onClick,
              dayResources: dayResources,
            }}
          />
        </>
      )
    }, [dayResources, resourceTypes, resources, users, userTypes])
  /**
   * Render output
   */
  return (
    <>
      <RenderWeek />
      <Modals />
    </>
  )
}

export default BoardsWrapper
